// A successful decision resolves only its proposal and its source evaluation.
// The server refresh remains authoritative and can restore any newer action.
export const resolveDecidedProposal = (attention, proposal) => {
  if (!attention || !Array.isArray(attention.items)) return attention;
  const items = attention.items.filter((item) => !(
    (item.source_type === 'PRACTICE_PROPOSAL' && item.id === proposal.id)
    || (item.source_type === 'WATCH_CONDITION'
      && item.bot_id === proposal.bot_id
      && item.symbol === proposal.symbol
      && item.evaluation_id === proposal.originating_evaluation_id)
  ));
  const perBot = {};
  items.forEach((item) => {
    const key = String(item.bot_id);
    perBot[key] = (perBot[key] || 0) + 1;
  });
  return {
    ...attention,
    items,
    open_total: items.length,
    per_bot: perBot,
    severity: items.some((item) => item.severity === 'URGENT')
      ? 'URGENT' : items.length ? 'ATTENTION' : 'OK',
  };
};
